import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PortalVenueInfo } from '@tix/event-buyer/services';
import { TixEventsListComponent } from 'libs/event-buyer/components/src/lib/events-list/events-list.component';

import { TixPortalService } from '@tix/event-buyer/services';
import { Observable } from 'rxjs';
import { EventObject } from '@tix/shared/utils';
import { Moment } from 'moment';
import * as moment from 'moment';

@Component({
  selector: 'tix-event-front-calendar-card',
  templateUrl: './event-front-calendar-card.component.html',
  styleUrls: ['./event-front-calendar-card.component.scss']
})
export class EventFrontCalendarCardComponent implements OnInit {
  isShowSoldOut: Boolean;

  @ViewChild('EventItemCard') EventListCard: TixEventsListComponent;

  @Input() event: EventObject;

  @Input() calendarLastDay: Date;

  venueId: string;
  lastCalendarSevenDays: string[];
  venueDetails$: Observable<PortalVenueInfo>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private portalService: TixPortalService
  ) {}

  getLastSevenDays(dateInput: Date): string[] {
    const lastSevenDays: string[] = [];
    dateInput.setHours(1);
    for (let i = 0; i < 7; i++) {
      const date = new Date(dateInput);
      date.setDate(date.getDate() - i);
      lastSevenDays.push(date.toISOString().slice(0, 10));
    }

    return lastSevenDays;
  }

  ngAfterViewInit() {
    if (this.route.snapshot.params['venueId']) {
      this.venueId = this.route.snapshot.params['venueId'];
      this.venueDetails$ = this.portalService.getVenueInfo(this.venueId);
    } else {
      if (!this.venueId) {
        this.route.data.subscribe(data => {
          this.venueId = data['venueId'];
          this.venueDetails$ = this.portalService.getVenueInfo(this.venueId);
        });
      }
    }

    this.isShowSoldOut =
      this.EventListCard?.showIsSoldOut || this.EventListCard?.showIsExpired;
  }
  OriginTopRight(eventDate: Moment): boolean {
    const date = moment(eventDate, 'YYYY-MM-DDTHH:mm:ss');
    return date.day() === 6;
  }

  OriginTop(eventDate: Moment): boolean {
    const date = moment(eventDate, 'YYYY-MM-DDTHH:mm:ss');

    return date.day() != 6 && date.day() != 0;
  }

  OriginBottomRight(eventDate: Moment): boolean {
    const date = moment(eventDate).format('YYYY-MM-DDTHH:mm:ss');
    return `${date}`.slice(0, 10) === this.lastCalendarSevenDays[0];
  }
  OriginBottomLeft(eventDate: Moment): boolean {
    const date = moment(eventDate).format('YYYY-MM-DDTHH:mm:ss');

    return `${date}`.slice(0, 10) === this.lastCalendarSevenDays[6];
  }
  OriginBottom(eventDate: Moment): boolean {
    const date = moment(eventDate).format('YYYY-MM-DDTHH:mm:ss');
    return this.lastCalendarSevenDays.includes(`${date}`.slice(0, 10));
  }

  OriginTopLeft(eventDate: Moment): boolean {
    const date = moment(eventDate, 'YYYY-MM-DDTHH:mm:ss');
    return date.day() === 0;
  }

  openPurchasingPortal(eventInstanceId: string) {
    const url = this.router
      .createUrlTree(['/venue', this.venueId], {
        queryParams: {
          searchEvent: eventInstanceId,
          open: eventInstanceId,
          selectedEvent: eventInstanceId
        }
      })
      .toString();

    window.open(url, '_blank');
  }

  ngOnInit(): void {
    this.lastCalendarSevenDays = this.getLastSevenDays(this.calendarLastDay);
  }
}
